/** Date helpers. Everything displayed uses the device's locale and time zone. */

export function formatDay(
  date: Date,
  options: Intl.DateTimeFormatOptions = { month: "long", day: "numeric", year: "numeric" },
  locale?: string,
): string {
  return new Intl.DateTimeFormat(locale, options).format(date);
}

/** YYYY-MM-DD for the local calendar day. */
export function localDayKey(date: Date): string {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}

/** "today", "tomorrow", "in 5 days", "yesterday", "3 days ago". */
export function relativeDays(target: Date, now: Date): string {
  const day = (d: Date) => Date.UTC(d.getFullYear(), d.getMonth(), d.getDate());
  const diff = Math.round((day(target) - day(now)) / 86_400_000);
  if (diff === 0) return "today";
  if (diff === 1) return "tomorrow";
  if (diff === -1) return "yesterday";
  return diff > 0 ? `in ${diff} days` : `${-diff} days ago`;
}

/** Calendar date for an event start (traditional sabbats are all-day YYYY-MM-DD). */
export function eventDate(start: string): Date {
  return start.length === 10 ? new Date(`${start}T12:00:00`) : new Date(start);
}

export function monthStart(date: Date): Date {
  return new Date(date.getFullYear(), date.getMonth(), 1);
}

export function addMonths(date: Date, n: number): Date {
  return new Date(date.getFullYear(), date.getMonth() + n, 1);
}
